/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";

import RFQListPage from "./rfq";
import RFQDetailPage from "./rfq/detail";
import BookingListPage from "./bookings";
import BookingDetailPage from "./bookings/detail";
import DeliveryTrackingPage from "./delivery";
import DeliveryTripDetailPage from "./delivery/detail";
import FinancePage from "./finance";
import FinanceInvoiceDetailPage from "./finance/detail";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/edit";

import ManagePromotion from "./manage-promotion";
import AddPromotion from "./manage-promotion/addPromotion";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSystemSettings from "./manageSystemSettings";
import AddEmailTemplate from "./manageSystemSettings/addEmailTemplate";
import ManageStores from "./manageStores";
import AddStore from "./manageStores/add";
import StoreDetail from "./manageStores/view";
import ManageQrCode from "./manageQrCode";
import ManageRewards from "./manageRewards";
import AddRewards from "./manageRewards/add";
import RewardsDetail from "./manageRewards/view";
import ViewPromotion from "./manage-promotion/viewPromotion";
import ManageTransction from "./manage-transction";
import ViewTransction from "./manage-transction/viewTransction";
import ManageActivityLogs from "./manageActivityLogs";
import ManageFeedbackReports from "./manageFeedbackReports";
import PermissionDenied from "./permission-denied";
import ReportsPage from "./reports";
import SupportPage from "./support";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,

  ManageNotifications,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSystemSettings,

  ManagePromotion,
  AddPromotion,
  AddEmailTemplate,
  ManageStores,
  AddStore,
  StoreDetail,
  ManageQrCode,
  ManageRewards,
  AddRewards,
  RewardsDetail,
  ViewPromotion,
  ManageTransction,
  ViewTransction,
  ManageActivityLogs,
  ManageFeedbackReports,
  PermissionDenied,
  RFQListPage,
  RFQDetailPage,
  BookingListPage,
  BookingDetailPage,
  DeliveryTrackingPage,
  DeliveryTripDetailPage,
  FinancePage,
  FinanceInvoiceDetailPage,
  ReportsPage,
  SupportPage,
};